import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _VIDEO_URL = "video";

export async function getVideoList(params) {
    const response = await ApiBase.get(`${_VIDEO_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function getVideoDetail(id) {
    const response = await ApiBase.get(`${_VIDEO_URL}/${id}`);

    return response;
}

export async function createVideo(params) {
    const response = await ApiBase.post(`${_VIDEO_URL}`, params, { headers: { ['Content-type']: "multipart/form-data" } });
    if (response.success) toast.success(i18n.t("SUCCESS_TO_CREATE_VIDEO"))

    return response;
}

export async function updateVideo(id, params) {
    const response = await ApiBase.patch(`${_VIDEO_URL}/${id}`, params, { headers: { ['Content-type']: "multipart/form-data" } });
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_VIDEO"))

    return response;
}